import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import { selectUser } from "lib/features/user/userSlice";
import { useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import { Toaster } from "sonner";
import { APP_ID } from "util/sendbirdHelper";
import routes from "./routes";

const App = () => {
  const content = useRoutes(routes);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const user = useSelector(selectUser);

  return (
    <>
      <SendbirdProvider
        appId={APP_ID}
        userId={user?.id?.toString() || ""}
        breakpoint={isMobile}
      >
        <Toaster />
        {content}
      </SendbirdProvider>
    </>
  );
};
export default App;
